import {Indexed} from '@iiiristram/ts-type-utils'
import {makeKey} from '@logistics-frontend/utils/makeKey'

import {TypedRequestConfig} from './types'
import {equals, flow, get, negate} from '@logistics-frontend/utils'

export function batch<TArgs extends unknown[], TRes>(
  fn: (...args: TArgs) => Promise<TRes>,
  getKey: (...args: TArgs) => string = makeKey,
) {
  const hash: Indexed<Promise<TRes> | undefined> = {}

  return function batchInner(...args: TArgs) {
    const key = getKey(...args)
    let promise = hash[key]
    if (promise) return promise

    function clearCache(res: TRes | Error) {
      hash[key] = undefined

      if (res instanceof Error) {
        throw res
      }

      return res
    }

    promise = fn(...args).then(clearCache, clearCache)

    hash[key] = promise
    return promise
  }
}

export function addHeaders<T extends TypedRequestConfig>(config: T, headers: Record<string, string>) {
  return {
    ...config,
    headers: {
      ...config.headers,
      ...headers,
    },
  }
}

const isNotDisabledHeadersMode = flow(get('meta.standardHeadersMode'), negate(equals('disable')))
export function addSafeHeaders<T extends TypedRequestConfig>(config: T, headers: Record<string, string>) {
  return {
    ...config,
    headers: {
      ...config.headers,
      // чтобы корректно послать CORS запрос config.meta?.standardHeadersMode должен быть disable
      ...(isNotDisabledHeadersMode(config) ? headers : {}),
    },
  }
}
